<template>
   <div class='base'>
    <homePageHeader></homePageHeader>
    <img class='banner' :src='banner' @click='intoView("title")'>
    <div class='title'>
      <div class='title_text'>产品项目概览</div>
      <img :src='line'>
    </div>
    <div class='product_list'>
      <img class='productImg' :src='product1'>
      <img class='productImg' :src='product8'>
      <img class='productImg' :src='product2'>
      <img class='productImg' :src='product3'>
      <img class='productImg' :src='product4'>
      <img class='productImg' :src='product5'>
      <img class='productImg' :src='product6'>
      <img class='productImg' :src='product7'>
    </div>
    <div class='base_bottom'>
      <img class='contact1' :src='contact1'>
      <div class='bottom_bar' @click='intoView("about")'>
        <div id='inBottomBox'>
          <div id='bottom_bar_text'>缤纷APP产品，等你来选！</div>
          <div id='bottom_bar_btn'><div id='btn_text'>联系我们</div></div>
        </div>
      </div>
      <img class='contact2' :src='contact2'>
    </div>
    <div class='about'>
      <div class='about_base'>
        <div class='about_part'>
          <img class='single_icon' :src='aboutLogo'>
          <div class='company'>上海伍东信息科技有限公司</div>
        </div>
        <div class='about_part part_add'>
          <div class='msg_title'>公司</div>
          <div class='msg'>产品中心</div>
          <div class='msg'>联系我们</div>
        </div>
        <div class='about_part'>
          <div class='msg_title'>联系我们</div>
          <div class='msg'>media@goinmob.com</div>
          <div class='msg'>021-56623536</div>
        </div>
        <div class='about_part'>
          <div class='msg_title'>地址</div>
          <div class='msg'>上海市浦东新区博霞路22号405室</div>
        </div>
      </div>
      <div class='examine'>
        <div class='examine_text'>Copyright @2019-2022 上海伍东信息科技有限公司 <a href='https://beian.miit.gov.cn/' target="_blank">沪ICP备2021034481号-1</a></div>
      </div>
    </div>
   </div>
</template>

<script>
import homePageHeader from './header'

export default {
  name: 'homePage',
  data () {
    return {
      banner: require('../assets/img/banner.jpg'),
      line: require('../assets/img/line.png'),
      product1: require('../assets/img/app_1.png'),
      product2: require('../assets/img/app_2.png'),
      product3: require('../assets/img/app_3.png'),
      product4: require('../assets/img/app_4.png'),
      product5: require('../assets/img/app_5.png'),
      product6: require('../assets/img/app_6.png'),
      product7: require('../assets/img/app_7.png'),
      product8: require('../assets/img/app_8.png'),
      contact1: require('../assets/img/contact_img_1.png'),
      contact2: require('../assets/img/contact_img_2.png'),
      aboutLogo: require('../assets/img/logo_white.png')
    }
  },
  components: {
    homePageHeader
  },
  methods: {
    intoView (data) {
      document.getElementsByClassName(data)[0].scrollIntoView()
    }
  }
}
</script>

<style scoped>
    .base {
      width: 100%;
      height: auto;
      background-color: #F6F8FB;
    }
    .banner {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .title {
      width: 100%;
      height: 200px;
      text-align:center;
      margin-top: 80px;
    }
    .title_text {
      width: 100%;
      height: 85px;
      opacity: 1;
      font-size: 50px;
      font-weight: 600;
      color: #000000;
    }
    .product_list {
      width: 100%;
      text-align: center;
    }
    .productImg {
      width: 95%;
      height: auto;
      margin-bottom: 30px;
    }
    .base_bottom {
      background-color: #FFFFFF;
      height: 400px;
      cursor: pointer;
    }
    .contact1 {
      width: 152px;
      height: 60%;
      display: inline-flex;
      vertical-align: top;
    }
    .contact2 {
      width:608px;
      height:90%;
      display: inline-flex;
      vertical-align: top;
    }
    .bottom_bar {
      width: calc(100% - 608px - 152px);
      height: 60%;
      display: inline-block;
      text-align: center;
    }
    #inBottomBox {
      display: inline-block;
    }
    #bottom_bar_text {
      width: 100%;
      height: 44px;
      opacity: 1;
      font-size: 33px;
      font-weight: 550;
      color: #000000;
      margin-top: 100px;
    }
    #bottom_bar_btn {
      color: #FFFFFF;
      font-size: 30px;
      font-weight: 500;
      text-align: center;
      width: 200px;
      height:58px;
      background: #1C8BF9;
      border-radius:10px;
      margin-top: 50px;
    }
    #btn_text {
      position: relative;
      top:50%;
      transform:translateY(-50%);
    }
    .about {
      width: 100%;
      height: 300px;
      background: #242730;
      text-align: center;
    }
    .about_base {
      width: 90%;
      height: 100%;
      display: inline-flex;
    }
    .about_part {
      width: 25%;
      height: 60%;
      margin-top:50px;
    }
    .single_icon {
      width: 180px;
      height: 35px;
    }
    .company {
      color: #6d6c6c;
      font-size: .9em;
      font-weight: 700;
    }
    .msg_title {
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 600;
      text-align: left;
    }
    .msg {
      color: #6d6c6c;
      font-size: .9em;
      font-weight: 700;
      margin-top: 20px;
      text-align: left;
    }
    .part_add {
      margin-left: 10%;
    }
    .examine {
      width: 100%;
      height: 60px;
      background: #17191D;
      text-align: center;
    }
    .examine_text {
      font-size: 12px;
      font-weight: 700;
      color: #6d6c6c;
      position: relative;
      top:50%;
      transform:translateY(-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue